import getMatchingEnumValue from 'common/src/utils/typescriptUtils/getMatchingEnumValue';
import {ConditionSignalType, ConditionSignalTypeName} from './excelToCampaign.enums';
import {CampaignSignal, RemoteCampaignSignal} from './excelToCampaign.types';

function toCampaignSignal(remoteSignal: RemoteCampaignSignal): CampaignSignal {
  return {
    ...remoteSignal,
    signalTypeName: getMatchingEnumValue(
      ConditionSignalType,
      ConditionSignalTypeName,
      remoteSignal.signalType,
    ),
  };
}

export {toCampaignSignal};
